export const drefImages = {
  优质用户: {
    url: 'https://i9.taou.com/maimai/p/23535/8191_53_417gtKRHZFyRmKjb',
    ratio: 1,
  },
  优质用户_v6: {
    url: 'https://i9.taou.com/maimai/p/26132/3856_53_81sVAyqFXQqiZU1z',
    ratio: 3.1,
  },
  已关注: {
    url: 'https://i9.taou.com/maimai/p/25838/732_53_5bsWG1F77rGztJ',
    ratio: 2.56,
  },
  已关注_v6: {
    url: 'https://i9.taou.com/maimai/p/26176/2572_53_42TnBVoo2tGqK8rr',
    ratio: 2.4,
  },
  好友: {
    url: 'https://i9.taou.com/maimai/p/23265/2937_53_VIgxaQGZnN6lnp',
    ratio: 1.74,
  },
  好友_v6: {
    url: 'https://i9.taou.com/maimai/p/26132/4596_53_81NaZapSUAxe227T',
    ratio: 1.7,
  },
  同事: {
    url: 'https://i9.taou.com/maimai/p/24830/7873_53_51RYhe5qctLCFNZZ',
    ratio: 1.86,
  },
  同事_v6: {
    url: 'https://i9.taou.com/maimai/p/26132/4598_53_12sse1Us3CwsIPDN',
    ratio: 1.61,
  },
  前同事: {
    url: 'https://i9.taou.com/maimai/p/24830/7560_53_23WLH4MwsGJPq9',
    ratio: 2.6,
  },
  前同事_v6: {
    url: 'https://i9.taou.com/maimai/p/26132/4600_53_3Gj2CUsl1RfHxl',
    ratio: 2.4,
  },
  校友: {
    url: 'https://i9.taou.com/maimai/p/24830/7874_53_62MlXLRnbVD05Od7',
    ratio: 1.86,
  },
  校友_v6: {
    url: 'https://i9.taou.com/maimai/p/26132/4597_53_w1yN8d4BF9jqp5',
    ratio: 1.71,
  },
  脉脉热榜: {
    url: 'https://i9.taou.com/maimai/p/25235/9286_6_21Jk0ahC4CVALVRK',
    ratio: 4.3,
  },
  引用作者: {
    url: 'https://i9.taou.com/maimai/p/26182/6574_53_6BLXbVQcyLJdlV',
    ratio: 0.8,
  },
  已收听: {
    url: 'https://i9.taou.com/maimai/p/23265/2761_53_31Tji65H1UxZvXFZ',
    ratio: 2.56,
  },
  仅同行可见: {
    url: 'https://i9.taou.com/maimai/p/29172/8036_6_22evVLQ7kXZn2GXY',
    ratio: 3.8,
  },
  仅员工可见: {
    url: 'https://i9.taou.com/maimai/p/29172/8037_6_34aQC4CejeQ0sQ',
    ratio: 3.9,
  },
  校友会: {
    url: 'https://i9.taou.com/maimai/p/26566/7197_53_uQrIlNcAnyV5ZZ',
    ratio: 1.4,
  },
  推广: {
    url: 'https://i9.taou.com/maimai/p/27287/9919_6_47VaKZ7tIqF06I',
    ratio: 1.65,
  },
};
